import axios from "axios";

export const fetchGetUserDetail = async (userId: string) => {
  return await axios.get(`/api/user/${userId}`);
};
